export class SurveySubmissionModel {
    public code: string = '';

    public Answers: AnswerIdValueModel[] = [];
}

export class AnswerIdValueModel {
    public questionId: number = -1;
    public answerId: number = 0;

    public answer: string = '';
    public mcqAnswers: McqAnswerModel[] = [];
    public matrixAnswers: MatrixAnswerModel[] = [];
    

    constructor(key: number, value: string, mcqAnswers: McqAnswerModel[], matrixAnswers: MatrixAnswerModel[]) {
        this.questionId = key;
        this.answer = value;
        this.mcqAnswers = mcqAnswers;
        this.matrixAnswers = matrixAnswers;
    }
}

export class McqAnswerModel {
    public mcqOptionId: number = -1;
    public mcqAnswerId: number = -1;
    public answerEn: string = '';
    public answerFr: string = '';

    constructor(mcqOptionId: number, answerEn: string, answerFr: string) {
        this.mcqOptionId = mcqOptionId;
        this.answerEn = answerEn;
        this.answerFr = answerFr;
    }
}

export class MatrixAnswerModel {
    public matrixAnswerId: number = -1;
    public matrixColumnId: number = -1;
    public matrixRowId: number = -1;
    public answerEn: string = '';
    public answerFr: string = '';

    constructor(matrixRowId: number, matrixColumnId: number, answerEn: string, answerFr: string) {
        this.matrixRowId = matrixRowId;
        this.matrixColumnId = matrixColumnId;
        this.answerEn = answerEn;
        this.answerFr = answerFr;
    }
}
